import Layout from '@/components/layout/Layout.vue'
import JuliangForm from '@/views/sys/advertiser/project/create/Create.vue'
import JuliangV1Form from '@/views/sys/advertiser/project/create-v1/Create.vue'
import JuliangUgForm from '@/views/sys/advertiser/project/create-ug/Create.vue'
import JuliangUniForm from '@/views/sys/advertiser/project/create-uni/Create.vue'
import KuaishouForm from '@/views/sys/ad-task/kuaishou/Kuaishou.vue'
import KuaishouNewForm from '@/views/sys/ad-task/kuaishou/KuaishouNew.vue'
import BaiduForm from '@/views/sys/ad-task/baidu/Baidu.vue'
import SharedForm from '@/views/sys/ad-task/shared/Shared.vue'
import { getAdTasks, deleteAdTasks } from '@/api/ad-task'
import { getAdTasks as getAdTasksBaiDu, deleteAdTasks as deleteAdTasksBaiDu } from '@/api/ad-task-baidu'
import { getAdTaskStatus } from '@/api/constant'
import { getCorporations } from '@/api/open'
import Upload from '@/views/sys/ad-task/kuaishou/upload/Upload.vue'
import { getAllTeams } from '@/api/open'

const pageName = 'ad_tasks'

export default {
    name: pageName,
    components: {
        Layout,
        JuliangForm,
        KuaishouForm,
        BaiduForm,
        Upload,
        SharedForm,
        JuliangV1Form,
        JuliangUgForm,
        JuliangUniForm,
        KuaishouNewForm,
    },
    data () {
        return {
            media: this.$route.params.media,
            data: [],
            loading: false,
            selectedRowKeys: [],
            model: {},
            showForm: false,
            showV1Form: false,
            showUgForm: false,
            showUniForm: false,
            deliveryType: 'bid',
            showSharedForm: false,
            showUpload: false,
            showNewForm: false,
            queryParam: {
                task_type: 1,
            },
            status: [],
            result: {
                success: [],
                errors: []
            },
            tableGrid: this.setTable(),
            corporations: [],
            teams: {},
            sourceTypes: [{id:1, name:'正常'}, {id:2, name:'素材检测'}],
        }
    },
    beforeDestroy() {
        // 组件销毁时，移除全局的键盘事件监听器
        window.removeEventListener('keydown', this.handleKeyDown);
    },
    mounted() {
        // 组件挂载时，添加全局的键盘事件监听器
        window.addEventListener('keydown', this.handleKeyDown);
        
        const segments = this.$route.path.split('/')
        this.media = segments[segments.length - 1]
        getCorporations().then(res=>{ this.corporations = res.data.list || {} })
        getAllTeams().then(res=>{ this.teams = res.data.list || {} })
        getAdTaskStatus().then(res => {
            this.status = res.data.list || []
        }).finally(() => {
            this.getData()
        })
    },
    methods: {
        handleKeyDown(event) {
            if (event.key === 'Enter') {
                this.search()
            }
        },
        setTable() {
            let table = this.$helper.tableGrid(pageName)
            table.border = 'inner'
            table.radioConfig = { checkField: 'id' }
            table.columns = this.setColumns()
            return table
        },
        setColumns() {
            let columns = []

            const segments = this.$route.path.split('/')
            this.media = segments[segments.length - 1]

            // 全域投放：不显示原小组/被共享小组，广告数量改为项目数量（广告主数量×抖音号数量）
            if (this.deliveryType === 'uni' && this.media === 'juliang') {
                return [
                    { width: 60, type: 'checkbox', fixed: 'left' },
                    { width: 80, title: 'ID', field: 'id', fixed: 'left' },
                    { minWidth: 180, title: '任务名称', field: 'name', formatter: 'empty', fixed: 'left' },
                    { minWidth: 120, title: '广告主数量', formatter: item => {
                        return item.row.advertiser_ids.length
                    }},
                    { minWidth: 120, title: '项目数量', formatter: item => {
                        const awemeCount = item.row.params && item.row.params.aweme_id
                            ? item.row.params.aweme_id.length
                            : 0
                        return awemeCount
                    }},
                    { minWidth: 120, title: '完成数量', field: 'result', slots: { default: 'result' } },
                    { minWidth: 120, title: '状态', field: 'status', slots: { default: 'status' } },
                    { minWidth: 180, title: '创建时间', field: 'created_at' },
                    { minWidth: 180, title: '更新时间', field: 'updated_at' },
                    { width: 220, title: '操作', field: 'action', fixed: 'right', slots: { default: 'action' } }
                ]
            }

            if (this.media === 'baidu') {
                columns = [
                    { width: 60, type: 'checkbox', fixed: 'left' },
                    { width: 80, title: 'ID', field: 'id', fixed: 'left' },
                    { minWidth: 180, title: '任务名称', field: 'name',  fixed: 'left', formatter: item => {
                        return item.row.name
                    } },
                    { minWidth: 120, title: '广告主数量', formatter: item => {
                        return item.row.advertiser_ids.length
                    }},
                    { minWidth: 120, title: '计划数量', formatter: item => {
                        return item.row.params.campaign_feed_num
                    }},
                    { minWidth: 120, title: '单元数量', formatter: item => {
                        return item.row.params.adgroup_feed_num
                    }},
                    { minWidth: 120, title: '完成数量', field: 'result', slots: { default: 'result' } },
                    { minWidth: 120, title: '状态', field: 'status', slots: { default: 'status' } },
                    { minWidth: 120, title: '原小组', field: 'team_id', formatter: item => {
                        return this.$helper.getItemName(this.teams, item.row.team_id) || '-'
                    }},
                    { minWidth: 180, title: '被共享小组', field: 'team_ids', formatter: item => {
                        return this.$helper.getItemName(this.teams, item.row.team_ids) || '-'
                    }},
                    { minWidth: 180, title: '创建时间', field: 'created_at' },
                    { minWidth: 180, title: '更新时间', field: 'updated_at' },
                    { width: 140, title: '操作', field: 'action', fixed: 'right', slots: { default: 'action' } }
                ]
            }  else if (this.media === 'kuaishou') {
                columns = [
                    { width: 60, type: 'checkbox', fixed: 'left' },
                    { width: 80, title: 'ID', field: 'id', fixed: 'left' },
                    { minWidth: 180, title: '任务名称', field: 'name', formatter: 'empty', fixed: 'left' },
                    { minWidth: 120, title: '广告主数量', formatter: item => {
                        return item.row.advertiser_ids.length
                    }},
                    { minWidth: 120, title: '广告组数量', formatter: item => {
                        return item.row.params.unit.num ?? 1
                    }},
                    { minWidth: 120, title: '完成数量', field: 'result', slots: { default: 'result' } },
                    { minWidth: 120, title: '状态', field: 'status', slots: { default: 'status' } },
                    { minWidth: 120, title: '原小组', field: 'team_id', formatter: item => {
                        return this.$helper.getItemName(this.teams, item.row.team_id) || '-'
                    }},
                    { minWidth: 180, title: '被共享小组', field: 'team_ids', formatter: item => {
                        return this.$helper.getItemName(this.teams, item.row.team_ids) || '-'
                    }},
                    { minWidth: 180, title: '创建时间', field: 'created_at' },
                    { minWidth: 180, title: '更新时间', field: 'updated_at' },
                    { width: 220, title: '操作', field: 'action', fixed: 'right', slots: { default: 'action' } }
                ]
            } else {
                columns = [
                    { width: 60, type: 'checkbox', fixed: 'left' },
                    { width: 80, title: 'ID', field: 'id', fixed: 'left' },
                    { minWidth: 180, title: '任务名称', field: 'name', formatter: 'empty', fixed: 'left' },
                    { minWidth: 120, title: '广告主数量', formatter: item => {
                        return item.row.advertiser_ids.length
                    }},
                    { minWidth: 120, title: '广告数量', formatter: item => {
                        return item.row.params.num || item.row.params.ad.num
                    }},
                    { minWidth: 120, title: '完成数量', field: 'result', slots: { default: 'result' } },
                    { minWidth: 120, title: '状态', field: 'status', slots: { default: 'status' } },
                    { minWidth: 120, title: '原小组', field: 'team_id', formatter: item => {
                        return this.$helper.getItemName(this.teams, item.row.team_id) || '-'
                    }},
                    { minWidth: 180, title: '被共享小组', field: 'team_ids', formatter: item => {
                        return this.$helper.getItemName(this.teams, item.row.team_ids) || '-'
                    }},
                    { minWidth: 180, title: '创建时间', field: 'created_at' },
                    { minWidth: 180, title: '更新时间', field: 'updated_at' },
                    { width: 280, title: '操作', field: 'action', fixed: 'right', slots: { default: 'action' } }
                ]
            }
            return columns
        },
        create(record) {
            this.model = record.id ? Object.assign({}, record) : {}
            this.showForm = true
        },
        createUg(record) {
            this.model = record.id ? Object.assign({}, record) : {}
            this.model.classify = 'CLASSIFY_INTERNAL'
            this.showUgForm = true
        },
        createV1(record) {
            this.model = record.id ? Object.assign({}, record) : {}
            this.showV1Form = true
        },
        createUni(record) {
            this.model = record ? { ...record } : {}
            this.showUniForm = true
        },
        /**
         * 复制任务下的广告主ID（全域投放列表操作使用）
         *
         * 任务存储的 advertiser_ids 是系统内部广告主ID，外部平台无法使用，
         * 因此优先取任务参数 params.advertisers 中的 advertiser_id（巨量广告主ID/out_id），
         * 仅在参数缺失时回退到内部 advertiser_ids，保证按钮始终有可复制内容。
         * 多个广告主以换行拼接，方便直接粘贴到巨量后台。
         *
         * @param {Object} record 列表行数据（全域投放任务）
         */
        copyAdvertiserIds(record) {
            if (!record) {
                return this.$message.warning('请先选择要复制的任务')
            }

            const advertisers = (record.params && Array.isArray(record.params.advertisers))
                ? record.params.advertisers
                : []
            const outIds = advertisers
                .map(item => item && item.advertiser_id)
                .filter(id => id)

            // 参数缺失（如历史任务）时回退到任务存储的广告主ID列表
            const rawIds = outIds.length > 0 ? outIds : (record.advertiser_ids || [])
            // 去重并统一为字符串，避免同一广告主被重复复制
            const ids = [...new Set(rawIds.filter(id => id).map(id => String(id)))]

            if (ids.length === 0) {
                return this.$message.warning('该任务暂无广告主ID')
            }

            this.$helper.clipboard(ids.join('\n'))
            this.$message.success(`已复制 ${ids.length} 个广告主ID`)
        },
        onDeliveryTypeChange(e) {
            this.deliveryType = e.target.value
            this.queryParam.task_type = this.deliveryType === 'uni' ? 2 : 1
            // 切换投放类型时重建列（全域与竞价列不同）
            this.tableGrid.columns = this.setColumns()
            this.search()
        },
        createNew(record) {
            this.model = record.id ? Object.assign({}, record) : {}
            this.showNewForm = true
        },
        shared(record = '') {
            let ids = []

            if (record && record.id) {
                // 单条共享
                ids = [record.id]
            } else {
                // 批量共享
                if (!this.selectedRowKeys.length) {
                    return this.$message.warning('请先选择要共享的任务')
                }
                ids = this.selectedRowKeys
            }

            this.model = {
                id: record.id || null,
                task_ids: ids,
                team_ids: record.team_ids || [],
            }

            this.showSharedForm = true
        },
        upload() {
            this.model =  {file_url:null, advertiser_id: null, shield_backward_switch:false}
            this.showUpload = true
        },
        destroy(record) {
            const del = ids => {
                if (this.media === 'baidu') {
                    deleteAdTasksBaiDu(this.media, ids).then(res => {
                        this.$message.destroy()
                        if (res && res.code === 0) {
                            this.$message.success('删除成功')
                            this.refresh()
                        }
                    })
                } else {
                    deleteAdTasks(this.media, ids, { task_type: this.queryParam.task_type }).then(res => {
                        this.$message.destroy()
                        if (res && res.code === 0) {
                            this.$message.success('删除成功')
                            this.refresh()
                        }
                    })
                }
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        getData() {
            this.selectedRowKeys = []
            this.tableGrid.loading = true
          
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            if (this.media === 'baidu') {
                getAdTasksBaiDu(json).then(res => {
                    this.tableGrid.pagerConfig.total = res.data.total
                    this.tableGrid.loading = false
                    this.tableGrid.data = res.data.list
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            } else {
                getAdTasks(this.media, json).then(res => {
                    this.tableGrid.pagerConfig.total = res.data.total
                    this.tableGrid.loading = false
                    this.tableGrid.data = res.data.list
                }).catch(() => {
                    this.tableGrid.loading = false
                })
            }
          
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {
                task_type: this.deliveryType === 'uni' ? 2 : 1,
            }
            this.search()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.getData()
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            this.getData()
        },
        handleRowChange(result) {
            this.selectedRowKeys = result.records.flatMap((item) => {
                return item.id
            })
        },
        accessTo(route) {
            return this.$helper.accessTo('AdTaskController', route)
        },
        showResult(task) {
            this.result.success = task.success
            this.result.errors = task.errors
        },
        close() {
            this.result.success = []
            this.result.errors = []
        } 
    },
    filters: {
        statusColor(status) {
            switch (status) {
                case 2:
                    return 'orange'
                case 3:
                    return 'green'
                case 5:
                    return 'red'
                default:
                    return ''
            }
        }
    },
}
